'use strict';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './quality.routes';
import QualityController from './quality.controller';
import QualityService from './quality.service';
import eqpPartners from './eqp-partners';
export default angular.module('eeComUiApp.quality', [
    uiRouter,
    eqpPartners
])
    .config(routing)
    .controller('QualityController', QualityController)
    .filter('htmlToPlaintext', function () {
    return function (text) {
        return text ? String(text).replace(/<[^>]+>/gm, '').replace('&nbsp;', ' ') : '';
    };
})
    .service('QualityService', QualityService)
    .name;
//# sourceMappingURL=index.js.map